import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import {
  Button,
  Divider,
  Drawer,
  Fab,
  Fade,
  IconButton,
  List,
  ListItem,
  useScrollTrigger,
} from "@mui/material";
import { Link, Outlet } from "react-router-dom";
import { Fragment, useCallback, useMemo, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import Footer from "@/components/Footer";
import useIsAuthenticated from "@/hooks/useIsAuthenticated";
const logo = require("@/assets/images/logo-tgv-inoui.png");
interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

interface ScrollTopProps {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children?: React.ReactNode;
}
function ScrollTop(props: ScrollTopProps) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (
      (event.target as HTMLDivElement).ownerDocument || document
    ).querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

export default function Layout(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const isAuth = useIsAuthenticated();
  const handleDrawerToggle = useCallback(() => {
    setMobileOpen((m) => !m);
  }, []);
  const authenticationBotton = useMemo(() => {
    if (!isAuth) {
      return (
        <Button
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 50, px: 3 }}
          component={Link}
          to={"/authentication/signin"}
        >
          Connexion
        </Button>
      );
    }
    return null;
  }, [isAuth]);
  const drawer = useMemo(() => {
    return (
      <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
        <Typography
          variant="h6"
          sx={{
            my: 2,
            "& img": {
              maxWidth: "100%",
              paddingLeft: "10px",
              paddingRight: "10px",
            },
          }}
        >
          <img src={logo} alt="Logo" />
        </Typography>

        <Divider />
        {/* <List>
          {navItems.map((item) => (
            <ListItem key={item} disablePadding>
              <ListItemButton sx={{ textAlign: "center" }}>
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          ))}
        </List> */}
        <List>
          <ListItem sx={{ justifyContent: "center" }}>
            {authenticationBotton}
          </ListItem>
        </List>
      </Box>
    );
  }, [handleDrawerToggle, authenticationBotton]);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Fragment>
      <Box>
        <AppBar position="static" color="transparent" enableColorOnDark>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                // textAlign: "center",
                display: { sm: "block" },
                padding: 2,
                "& img": {
                  // maxHeight: 200,
                  // marginRight: '10px',
                  width: 150,
                  maxWidth: "100%",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                },
              }}
            >
              <Link to={"/"}>
                <img src={logo} alt="Logo" />
              </Link>
            </Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              {authenticationBotton}
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: 240,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          sx={{
            p: 3,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            minHeight: "100vh",
          }}
        >
          <Toolbar id="back-to-top-anchor" />
          <Outlet />
        </Box>
      </Box>
      <ScrollTop {...props}>
        <Fab size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
      <Footer />
    </Fragment>
  );
}
